import {Icon} from 'antd';
import autobind from 'autobind-decorator';
import * as React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import {connect} from 'redux-scaffolding-ts';
import {ItemReference, QueryResult} from '../../../../core/stores/dataStore';
import SelectionInput from '../../../../core/ui/form/selectionInput';
import {ProjectTemplatesStore} from '../../../../stores/templates-store';


interface ProjectTemplatesFilterProps extends WithTranslation {
    companyId: string,
    onChange: (item: any) => void;
    placeholder?: string;
    multiple?: boolean;
}

interface ProjectTemplatesFilterState {
    currentProject?: string[] | string;
}

@connect(['projectTemplates', ProjectTemplatesStore])
class ProjectTemplatesFilter extends React.Component<ProjectTemplatesFilterProps, ProjectTemplatesFilterState> {

    private get ProjectTemplatesStore() {
        return (this.props as any).projectTemplates as ProjectTemplatesStore;
    }

    constructor(props: ProjectTemplatesFilterProps) {
        super(props);
        this.state = {
            currentProject: undefined,
        };
    }

    componentWillMount() {
        this.ProjectTemplatesStore.changeUrl(this.props.companyId);
    }

    @autobind
    private async getProjectTemplates(searchQuery: string): Promise<QueryResult<ItemReference>> {
        var result = await this.ProjectTemplatesStore.getAllAsync({
            searchQuery: searchQuery,
            skip: 0,
            take: 25,
            orderBy: [{ field: 'title', direction: "Ascending", useProfile: true }]
        }) || { count: 0, items: [] };

        return {
            count: result.count,
            items: result.items.map(o => ({
                id: `${o.id}`,
                title: `${o.title}`
            } as ItemReference))
        } as QueryResult<ItemReference>
    }

    @autobind
    private onChange(item: any) {
        this.props.onChange(item?.id ? item.id : item as any || undefined)
        this.setState({ currentProject: item })
    }

    public render() {
        const { t } = this.props;

        return (
            <SelectionInput
                content={(o) =>
                    <div>
                        <Icon type="layout" />
                        <span>&nbsp;{o ? o.title : ""}</span>
                    </div>}
                searchable
                nullable
                placeholder={t('Project Template')}
                query={this.getProjectTemplates}
                value={this.state.currentProject as any}
                multiple={this.props.multiple}
                minWidth={400}
                onChange={this.onChange} />
        );
    }
}

// Wire up the React component to the Redux store
export default withTranslation()(ProjectTemplatesFilter);